export const preClassifications = [
    {classificationName: 'Preview Reject - Positive', classificationId: 75},
    {classificationName: 'Preview Reject - Positive w/Amount', classificationId: 76},
    {classificationName: 'Preview Reject - Negative', classificationId: 77},
    {classificationName: 'Preview Reject - Negative DNC BU', classificationId: 78},
    {classificationName: 'Preview Reject - Negative DNC Skill', classificationId: 79},
    {classificationName: 'Preview Reject - Negative Other', classificationId: 80}
];

